import { EducationProviderService } from '@/services/education-provider';
import {
  ApiPaginationParams,
  ApiQueryParams,
  ApiReactQueryOptions,
} from '@/types/api';
import { ApiPaginatedEducationProvider } from '@/types/education-provider';
import { useQuery } from '@tanstack/react-query';

export function useEducationProviders(opts?: {
  filters?: ApiQueryParams;
  pagination?: ApiPaginationParams;
  options?: ApiReactQueryOptions<ApiPaginatedEducationProvider>;
}) {
  const { filters, pagination, options } = opts ?? {};

  return useQuery({
    queryKey: [EducationProviderService.PATH, filters, pagination],
    queryFn: () =>
      EducationProviderService.getEducationProviders(filters, pagination),
    ...options,
  });
}
